import { makeHttpRequest } from "@/shared";

import { mapCalculatedSellingFromServer } from "./mappers/mapCalculatedSellingFromServer";

export const removeDiscountFromSelling = async (sessionKey) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/remove/discount`,
            method: "DELETE",
        })
    ).data;

    return mapCalculatedSellingFromServer(response.data);
};
